// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2B31R","inputDescription":"styles_inputDescription__xuXwl"};